import { Dispatch, FC, useState, useEffect, useCallback } from "react";
import { ReportContentFilterInterface } from "../../../middleware/interfaces/report/report-content-filter_interface";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { StopEventPropagation } from "../../../helper/ui/methods";

interface ReportContentFilterDialogProps {
  reveal: boolean;
  state: UserStateInterface;
  setReportContentFilterDialogReveal: Dispatch<React.SetStateAction<boolean>>;
  dispatch: Dispatch<any>;
}

const ReportContentFilterDialog: FC<ReportContentFilterDialogProps> = ({
  reveal,
  state,
  setReportContentFilterDialogReveal,
  dispatch,
}) => {
  const [updatedReportContentfilter, setUpdatedReportContentfilter] =
    useState<ReportContentFilterInterface>();

  useEffect(() => {
    if (state.openReport?.reportContentFilter) {
      setUpdatedReportContentfilter(state.openReport?.reportContentFilter);
    }
  }, [state.openReport]);

  const HandleCancelClick = useCallback(() => {
    setReportContentFilterDialogReveal(false);
  }, [setReportContentFilterDialogReveal]);

  const HandleApplyClick = useCallback(() => {
    const filteredReport = {
      ...state.openReport,
      reportContentFilter: updatedReportContentfilter,
    };

    dispatch({
      type: "FILTER_REPORT",
      payload: filteredReport,
    });
    setReportContentFilterDialogReveal(false);
  }, [
    dispatch,
    setReportContentFilterDialogReveal,
    updatedReportContentfilter,
    state.openReport,
  ]);

  const HandleCheckboxChange = (index: number) => {
    if (!updatedReportContentfilter) return;

    const updatedGroupData = [
      ...updatedReportContentfilter.reportElementGroupData,
    ];
    updatedGroupData[index].reportElementGroupData.reportElementGroupFilter =
      !updatedGroupData[index].reportElementGroupData.reportElementGroupFilter;

    setUpdatedReportContentfilter({
      ...updatedReportContentfilter,
      reportElementGroupData: updatedGroupData,
    });
  };

  if (!reveal) {
    return null;
  }

  return (
    <div
      className="dialogCover"
      onClick={StopEventPropagation}
      onDoubleClick={StopEventPropagation}
    >
      <div className="dialog">
        <div className="dialogHeader">
          <div className="dialogHeading">
            <h2 className="dialogTitle">Filter clashes</h2>
          </div>
          <span className="dialogClose" onClick={HandleCancelClick}>
            ×
          </span>
        </div>
        <div id="ReportContentFilterWrapper">
          {updatedReportContentfilter!.reportElementGroupData.map(
            (group, index) => (
              <label
                key={index}
                className={
                  group.reportElementGroupData.reportElementGroupFilter
                    ? "dialogCheckRow dialogCheckRowSelected"
                    : "dialogCheckRow"
                }
              >
                <input
                  type="checkbox"
                  checked={
                    group.reportElementGroupData.reportElementGroupFilter
                  }
                  onChange={() => HandleCheckboxChange(index)}
                />
                {/* these rows are clash groups, so the group's own colour is
                    the marker rather than a content-type icon */}
                <span
                  className="dialogCheckRowSwatch"
                  style={
                    {
                      "--dialogCheckRowSwatchColor":
                        group.reportElementGroupData.reportElementGroupColor.startsWith(
                          "#"
                        )
                          ? group.reportElementGroupData.reportElementGroupColor
                          : "#" +
                            group.reportElementGroupData
                              .reportElementGroupColor,
                    } as React.CSSProperties
                  }
                />
                <span className="dialogCheckRowLabel">
                  {group.reportElementGroupName}
                </span>
                <span className="dialogCheckRowDescription">
                  {group.reportElementGroupData.reportElementGroupCount}
                </span>
              </label>
            )
          )}
        </div>
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancel"
            value="Cancel"
            onClick={HandleCancelClick}
          />
          <input
            className="dialogPrimaryButton"
            type="button"
            name="apply"
            value="Apply"
            onClick={HandleApplyClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportContentFilterDialog;
